var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.73 26 4.64 3.77a1 1 0 0 0 1.63-.77v-3a6 6 0 0 0 6-6v-10a6 6 0 0 0-6-6h-12a6 6 0 0 0-6 6v10a6 6 0 0 0 6 6h5.73Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32v2a6 6 0 0 1-6 6h-5.73l-4.64 3.77a1 1 0 0 1-1.63-.77v-3a6 6 0 0 1-6-6v-8a6 6 0 0 1 6-6h4",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.66 11.03.34.35.35-.37a3.19 3.19 0 0 1 4.61-.05l.07.07a3.42 3.42 0 0 1 0 4.77l-3.5 3.56a2.14 2.14 0 0 1-3.05 0l-3.51-3.56a3.42 3.42 0 0 1 0-4.77v0a3.3 3.3 0 0 1 4.7 0v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 30a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0m5 0a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0m5 0a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLove);
export default __webpack_public_path__ + "static/media/message-love.ee4dd7c5a38ea866ceff021fdf0e3f81.svg";
export { ForwardRef as ReactComponent };